import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CondicaoDePagamento } from 'src/app/models/condicao-de-pagamento';
import { FormaDePagamento } from 'src/app/models/forma-de-pagamento';
import { Pedido } from 'src/app/models/pedido';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CondicaoDePagamentoService } from 'src/app/services/condicao-de-pagamento.service';
import { FormaDePagamentoService } from 'src/app/services/forma-de-pagamento.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { VisualizadorPdfComponent } from 'src/app/visualizador-pdf/visualizador-pdf.component';
import { Financa } from '../../models/financa';
import { PedidoService } from '../../services/pedido.service';
import { OctopusService } from '../../services/octopusService';
import { AttachmentType, CreatePaymentOutput, PaymentMethod, ProblemDetails } from '../../hopper/octopus/client';

declare const $: any;
@Component({
  selector: 'app-pagamento-octopus',
  templateUrl: './pagamento-octopus.component.html',
  styleUrls: ['./pagamento-octopus.component.scss']
})
export class PagamentoOctopusComponent implements OnInit {
  pedido: Pedido = new Pedido();
  financas: Financa[] = [];
  financaSelecionada: Financa = new Financa();
  idFinancaSelecionada: number = null;

  formaPag: FormaDePagamento = new FormaDePagamento();
  condPag: CondicaoDePagamento = new CondicaoDePagamento();

  pagamentoGerado = false;
  pagamento: CreatePaymentOutput = new CreatePaymentOutput();
  problemDetails: ProblemDetails = new ProblemDetails();

  public config: PerfectScrollbarConfigInterface = {};
  public readonly PaymentMethod = PaymentMethod;
  public readonly AttachmentType = AttachmentType;

  constructor(
    public dialogRef: MatDialogRef<PagamentoOctopusComponent>,
    public dialog: MatDialog,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private formaDePagamentoService: FormaDePagamentoService,
    private condicaoDePagamentoService: CondicaoDePagamentoService,
    private pedidoService: PedidoService,
    private hopperOctopusGiService: OctopusService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pedido = data.pedido;
  }

  ngOnInit() {
    this.buscarFormasDePagamentoComGateway();
  }

  buscarFormasDePagamentoComGateway() {
    this.carregandoService.mostra('buscarFormasDePagamentoComGateway');
    this.formaDePagamentoService.consultar().subscribe((data) => {
      const idFormasPagamentoGateway = data
        .filter((f) => f.gatewayOctopusId !== null && f.actionOctopusId !== null)
        .map((f) => f.id);

      this.buscarFinancas(idFormasPagamentoGateway);

      this.carregandoService.esconde('buscarFormasDePagamentoComGateway');
    }, (erro) => {
      this.carregandoService.esconde('buscarFormasDePagamentoComGateway');
      this.notificacaoService.erro('Não foi possível buscar as formas de pagamento com gateway.');
    });
  }

  buscarFinancas(idFormasPagamentoGateway: number[] = []) {
    this.carregandoService.mostra('buscarFinancas');

    this.pedidoService.consultarResumoFinanceiro(this.pedido.idCupom).subscribe(data => {
      this.financas = data.filter((f) => idFormasPagamentoGateway.includes(f.formaPag));

      if (data.length > 0) {
        this.idFinancaSelecionada = this.financas[0].idFinanca;
        this.alterarFinancaSelecionada(null);
      }

      this.carregandoService.esconde('buscarFinancas');
    }, (erro) => {
      this.carregandoService.esconde('buscarFinancas');
      this.notificacaoService.erro('Não foi possível buscar os dados financeiros do pedido.');
      console.error(erro);
    });
  }

  alterarFinancaSelecionada($event) {

    this.financaSelecionada = this.financas.find(p => p.idFinanca === this.idFinancaSelecionada);

    this.pagamentoGerado = false;
    this.pagamento = new CreatePaymentOutput();
    this.problemDetails = new ProblemDetails();

    this.buscarFormaPagamento();
    this.buscarCondicaoPagamento();

    if (this.financaSelecionada.chavePagamentoGateway !== null) {
      this.buscarOuGerarPagamentoGateway();
    }
  }

  buscarFormaPagamento() {
    this.carregandoService.mostra('buscarFormaPagamento');

    this.formaDePagamentoService.consultarPorId(this.financaSelecionada.formaPag).subscribe(data => {
      this.formaPag = data;

      this.carregandoService.esconde('buscarFormaPagamento');
    }, (erro) => {
      this.carregandoService.esconde('buscarFormaPagamento');
      this.notificacaoService.erro('Não foi possível buscar a forma de pagamento.');
      console.error(erro);
    });
  }

  buscarCondicaoPagamento() {
    this.carregandoService.mostra('buscarCondicaoPagamento');

    this.condicaoDePagamentoService.consultarPorId(this.financaSelecionada.condPag).subscribe(data => {
      this.condPag = data;

      this.carregandoService.esconde('buscarCondicaoPagamento');
    }, (erro) => {
      this.carregandoService.esconde('buscarCondicaoPagamento');
      this.notificacaoService.erro('Não foi possível buscar a condição de pagamento.');
      console.error(erro);
    });
  }

  buscarOuGerarPagamentoGateway() {
    this.carregandoService.mostra('buscarOuGerarPagamentoGateway');
    this.pagamentoGerado = false;
    this.pagamento = new CreatePaymentOutput();
    this.problemDetails = new ProblemDetails();

    this.hopperOctopusGiService.criarPagamentoViaGateway(this.pedido.idCupom, this.idFinancaSelecionada, "{}", "{}").subscribe(data => {
      this.pagamento = data.result || new CreatePaymentOutput();
      this.pagamentoGerado = this.pagamento.id !== null;

      this.carregandoService.esconde('buscarOuGerarPagamentoGateway');
    }, (erro) => {
      this.pagamentoGerado = false;
      this.problemDetails = erro.error;
      this.carregandoService.esconde('buscarOuGerarPagamentoGateway');
    });
  }

  validaGeraPagamentoGateway(): boolean {
    return this.idFinancaSelecionada === undefined || this.idFinancaSelecionada === null || this.idFinancaSelecionada === 0;
  }

  copiarAttachmentUrl(texto: string) {
    this.notificacaoService.sucesso(texto);
  }

  abrirPdf(url: string) {
    const dialogRef = this.dialog.open(VisualizadorPdfComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        arquivo: url,
        nomeArquivo: 'anexo.pdf',
        aceite: false
      },
      panelClass: 'modal-card'
    });
  }

  abrirJanela(url: string) {
    window.open(url, '_blank');
  }

  fechar() {
    this.dialogRef.close();
  }

  convertePaymentMethod(value: any): PaymentMethod {
    // A Api do GI não converte enums para string mas a do Octopus sim
    // Por isso tenho que fazer essa conversão
    switch (value) {
      case 0:
        return PaymentMethod.Cash;
      case 1:
        return PaymentMethod.Credit;
      case 2:
        return PaymentMethod.Debit;
      case 3:
        return PaymentMethod.Boleto;
      case 4:
        return PaymentMethod.BoletoPix;
      case 5:
        return PaymentMethod.Pix;
      case 6:
        return PaymentMethod.Link
    }
  }

  converteAttachmentType(value: any): AttachmentType {
    // A Api do GI não converte enums para string mas a do Octopus sim
    // Por isso tenho que fazer essa conversão
    switch (value) {
      case 0:
        return AttachmentType.Undefined;
      case 1:
        return AttachmentType.ImageFile;
      case 2:
        return AttachmentType.ImageBase64;
      case 3:
        return AttachmentType.PdfFile;
    }
  }
}
